import { Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavigationNodeId } from '@pwc/pwc-deals-web-common';
import { getProject } from 'features/project/projectSlice';
import { isProjectInactive } from 'common/helpers/projectStatusesUtils';
import { getNavigationTitle } from '../../common/helpers/getCustomNavigationTitles';
import { contentTypeHypotheses } from '../../common/components/proptypes/commonProptypes';
import ToggleGridList from '../../common/components/ToggleGridList/ToggleGridList';
import ContentList from '../contentList/ContentList';
import TagEditor from '../tagging/common/TagEditor/TagEditor';
import HypothesesGrid from './HypothesesGrid/HypothesesGrid';
import { updateKFAOrder } from './hypothesesService';
import AutoLock from '../../common/components/AutoLock';

const HypotyhesesView = ({
  projectId,
  viewGrid,
  data,
  handleToggleView,
  handleFilter,
  handleDelete,
  handleReorder,
  handleSort,
  sortKey,
  sortDir,
  fetchMore,
  hasMore,
  isFiltered,
  currentPage,
  pageSize,
  allRetrievedConnections,
}) => {
  const project = useSelector(getProject);
  const allowReorder = !isProjectInactive(project?.status);
  const KFATitle = getNavigationTitle(NavigationNodeId.KEY_FOCUS_AREAS);
  const { t } = useTranslation('');

  return (
    <>
      <div className="list-container-header">
        <h2 className="list-container-h2">{t('keyFocusArea', { KFATitle })}</h2>
        <ToggleGridList viewGrid={viewGrid} onClick={handleToggleView} />
      </div>
      <div className="tag-editor-container">
        <Formik initialValues={{ tags: [] }}>
          {() => (
            <TagEditor
              projectId={projectId}
              onSelect={handleFilter}
              tagsRight
              title={false}
              subtitle={false}
              allowCreateTags={false}
              placeholderText={t('filterByTag')}
              isCommentingAllowed
            />
          )}
        </Formik>
      </div>
      <AutoLock
        contentThreadIds={data.map((item) => item.contentThreadId)}
        projectId={Number(projectId)}
      >
        {viewGrid && (
          <HypothesesGrid
            projectId={projectId}
            kfasFilteredByTags={data}
            projectHasKfas={Boolean(data.length)}
            onDelete={handleDelete}
            dataLength={data.length}
            currentPage={currentPage}
            pageSize={pageSize}
            hasMore={hasMore}
            next={fetchMore}
            allRetrievedConnections={allRetrievedConnections}
          />
        )}
        {!viewGrid && (
          <ContentList
            contentType={contentTypeHypotheses}
            projectId={projectId}
            contentItems={data}
            projectHasContent={Boolean(data.length)}
            onDelete={handleDelete}
            onReorder={handleReorder}
            onSort={handleSort}
            sortKey={sortKey}
            sortDir={sortDir}
            updateSortOrderApiCall={updateKFAOrder}
            isFiltered={isFiltered}
            dataLength={data.length}
            hasMore={hasMore}
            next={fetchMore}
            allowReorder={allowReorder}
          />
        )}
      </AutoLock>
    </>
  );
};

export default HypotyhesesView;
